import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useContext, useState, useMemo, createContext } from 'react';
import { jsx } from '@emotion/react';

var initialValue = {
  onChangeActiveTab: function onChangeActiveTab() {/* noop */}
};
var StickyTabInnerContext = /*#__PURE__*/createContext(initialValue);
var useStickyTabInnerContext = function useStickyTabInnerContext() {
  return useContext(StickyTabInnerContext);
};
function StickyTabInnerContextProvider(_ref) {
  var children = _ref.children,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? initialValue : _ref$value;
  var _useState = useState(value.activeTab),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  var contextValue = useMemo(function () {
    return {
      activeTab: activeTab,
      onChangeActiveTab: function onChangeActiveTab(id) {
        return setActiveTab(id);
      }
    };
  }, [activeTab]);
  return jsx(StickyTabInnerContext.Provider, {
    value: contextValue
  }, children);
}

export { StickyTabInnerContextProvider, useStickyTabInnerContext };
//# sourceMappingURL=StickyTabInnerContext.js.map
